<template>
  <transition @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false" appear>
    <section :class="this.name">
      <div class="bg"></div>
      <div class="content">
        <detail v-if="activeLayer == 'revenge1'">
          <h1 class="detail__title"><img :src="`${$staticUrl}img/detail/revenge/title.png`" alt=""></h1>
          <p class="detail__sub-title"><img :src="`${$staticUrl}img/detail/revenge/sub-title.png`" alt=""></p>

          <slide ref="revenge1"
                 @transitionend="handleTransitionEnd"
                 @transitionstart="handleTransitionStart"
                 :slideList="layerData.revenge1.list"
                 :width="documentSize.width"
                 :height="layerData.revenge1.height"
                 :noPagination="true">
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/revenge/con-1.png`" alt="" slot="slide0"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/revenge/con-2.png`" alt="" slot="slide1"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/revenge/con-3.png`" alt="" slot="slide2"/>`,
          </slide>

          <div class="slide-dot-area">
            <button v-for="(item, index) in layerData.revenge1.list"
                    :class="['slide-dot-area__button', layerData.revenge1.index == index && 'slide-dot-area__button--active']"
                    @click="handleClickTo(index)">{{index}}
            </button>
          </div>
        </detail>
      </div>
    </section>
  </transition>
</template>
<script>
  import BasePage from "./mixins/basePage.js";

  export default {
    name: "revenge",
    mixins: [BasePage],
    data() {
      return {
        name: "revenge",
        contentData: [
          //{type: "bg", source: this.$staticUrl + "img/bg_5.jpg", objName: "bg"},
          {type:'bg', source:'https://vod.plaync.com/lineage/remaster0320/0320_remaster_bg5.mp4', objName:'bgmovie'},
          {type: "chr", source: this.$staticUrl + "img/obj_5_2.png", objName: "chr_2", x: 954, y: 92, arrow:'right', arrow:200},
          {type: "chr", source: this.$staticUrl + "img/obj_5_1.png", objName: "chr_1", x: 795, y: 108, delay: "-=1", arrow:200},
          {type: "txt", source: this.$staticUrl + "img/txt_5_tit.png", objName: "obj_tit", x: 152, y: 410, delay: "-=1.2"},
          {type: "txt", source: this.$staticUrl + "img/txt_5_stit.png", objName: "obj_stit", x: 136, y: 441},
          {type: "txt", source: this.$staticUrl + "img/txt_5_txt.png", objName: "obj_txt", x: 158, y: 557},
          {type: "btn", source: this.$staticUrl + "img/btn_5_1.png", objName: "revenge1", x: 156, y: 649},
        ],
        layerData: {
          revenge1: {
            list: 3,
            index: 0,
            height: 563,
            top: 262,
          },
        },

      };
    },
    methods: {
      canvasSet() {
        this.baseCavasSet(this.contentData);
      },
      enter(el, done) {
        this.baseEnter();
        this.canvasSet();
        //this.canvas.start();
        this.baseEnterMotion(el, done, this.contentData);
        this.enterMotion.play();
      },
      leave(el, done) {
        if (this.enterMotion) this.enterMotion.pause();
        this.baseLeaveMotion(el, done);
      },
    },
  };
</script>



